import {APIClient} from "../base";
import {PaginationInterface} from "../../../interfaces/PaginationInterface";
import {IntegrateInterface} from "../../../interfaces/private/IntegrateInterface";
import {getSyncEngineVersion} from "../../helpers/syncEngine";
import IntegrateV1Api from "./v1/Integrate";
import IntegrateV2Api from "./v2/Integrate";

/**
 * CRUD/cmsType stay on unversioned /integrate (legacy Integrate page).
 * Sync calls are routed to /v1 or /v2 by sync engine version.
 */
const IntegrateApi = {
    list: async (pagination: PaginationInterface) => await APIClient.get('/integrate', pagination),
    detail: async (id: number) => await APIClient.get('/integrate/' + id, {}),
    create: async (model: IntegrateInterface) => await APIClient.create('/integrate', model),
    update: async (id: number, model: IntegrateInterface) => await APIClient.update('/integrate/' + id, model),
    delete: async (id: number|string|any) => await APIClient.delete('/integrate/' + id, {}),
    cmsType: async () => await APIClient.get('/integrate/cms-type', {}),

    syncInvoice: async (...args: Parameters<typeof IntegrateV1Api.syncInvoice>) => {
        return getSyncEngineVersion() === 'v2'
            ? IntegrateV2Api.syncInvoice(...args)
            : IntegrateV1Api.syncInvoice(...args);
    },
    retryInvoice: async (...args: Parameters<typeof IntegrateV1Api.retryInvoice>) => {
        return getSyncEngineVersion() === 'v2'
            ? IntegrateV2Api.retryInvoice(...args)
            : IntegrateV1Api.retryInvoice(...args);
    },
    syncPayment: async (...args: Parameters<typeof IntegrateV1Api.syncPayment>) => {
        return getSyncEngineVersion() === 'v2'
            ? IntegrateV2Api.syncPayment(...args)
            : IntegrateV1Api.syncPayment(...args);
    },
    syncPayout: async (...args: Parameters<typeof IntegrateV1Api.syncPayout>) => {
        return getSyncEngineVersion() === 'v2'
            ? IntegrateV2Api.syncPayout(...args)
            : IntegrateV1Api.syncPayout(...args);
    },
    syncSubscription: async (...args: Parameters<typeof IntegrateV1Api.syncSubscription>) => {
        return getSyncEngineVersion() === 'v2'
            ? IntegrateV2Api.syncSubscription(...args)
            : IntegrateV1Api.syncSubscription(...args);
    },
};

export default IntegrateApi;
